import React from "react";
import { ForwardButton } from "~/assets/js/components/Button";
import i18n from "~/assets/js/Helpers/i18n";

const FRANCHISE_URL = "/franchise";

const Franchise = () => {
    return (
        <div className="footer_franchise">
            <div className="footer_franchise_text">
                <p className="footer_franchise_text__top">
                    {i18n.t("newFooter.franchise.topHeading")}
                </p>
                <p className="footer_franchise_text__bottom">
                    {i18n.t("newFooter.franchise.bottomHeading")}
                </p>
            </div>
            <div className="footer_franchise_button">
                <ForwardButton
                    label={i18n.t("newFooter.franchise.button")}
                    onClick={() => (window.location.href = FRANCHISE_URL)}
                    variant="reversed"
                    size={"SM"}
                />
            </div>
        </div>
    );
};

export default Franchise;
